/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIsZero } from '../../factoriesAny.js';
export var isZeroDependencies = {
  typedDependencies: typedDependencies,
  createIsZero: createIsZero
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIsZero.generated.js
// module id = 134
// module chunks = 0